import { useState } from "react";

import {
  canGoBackFrom,
  nextStepIndex,
  type GuideStepSpec,
} from "./start-guide-logic";

/**
 * Which step of a start guide is showing, and how the user moves through it:
 * confirm (the button), back, and the steps that move on by themselves.
 */
export function useGuideSteps<Step extends GuideStepSpec>({
  steps,
  onStepConfirm,
  onLastConfirm,
  initialStepIndex = 0,
}: {
  steps: readonly Step[];
  onStepConfirm?: (step: Step) => void;
  onLastConfirm?: () => void;
  // e.g. back from the payment, to the last step before it
  initialStepIndex?: number;
}) {
  const [stepIndex, setStepIndex] = useState(initialStepIndex);
  const step = steps[stepIndex]!;
  return {
    stepIndex,
    step,
    canGoBack: canGoBackFrom(steps, stepIndex),
    back: () => setStepIndex(stepIndex - 1),
    // `advanceAfterSeconds` ran out
    advance: () => setStepIndex(stepIndex + 1),
    confirm: () => {
      onStepConfirm?.(step);
      const next = nextStepIndex(stepIndex, steps.length);
      if (next === null) onLastConfirm?.();
      else setStepIndex(next);
    },
  };
}
